import React from "react";

import UslugiBlock from "../../components/PageBlocks/MoreInfoPages/UslugiBlock/UslugiBlock";
import { API_BASE_URL } from "../../context/appState";
import ServicePanel from "../../components/CommonBlocks/Panel/ServicePanel";

const UslugiPage = props => (
    <div className="uslugi_page_wrapper">
        <ServicePanel />
        <UslugiBlock initialData={props.initialData} />
    </div>
);

UslugiPage.getInitialProps = async function(context) {
    // let res = await fetch(`${API_BASE_URL}/section/uslugi/`);
    // const json = await res.json();
    return {
        // initialData: json,
        title: "Ремонтно-строительные услуги от PRORAB",
        description:
            "Компания PRORAB предлагает ремонтно-строительные услуги по отделке и ремонту квартир, домов, офисов и других помещений в городе Полтава и Полтавской области.",
        keywords: "",
        pageClasses: "relative_wrapper uslugi_page_wrapper",
        namespacesRequired: ["services"]
    };
};

export default UslugiPage;
